// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3N770","resendInfoText":"OnGoingPaymentBox_resendInfoText__1zSzz"};